module.exports = __webpack_public_path__ + "static/team-3439aa1f52348fd75ce6953dcb823569.jpg";